/**
 * スムーズスクロールなjs
 */

import { TweenMax, Power4 } from 'gsap';
import 'ScrollToPlugin';
import getHeaderSize from './getHeaderSize';

const smoothScroll = () => {
  const scroll = {
    animate(position) {
      const tweenOption = {
        scrollTo: {
          y: position,
          autoKill: false,
          force3D: true,
          duration: 1600,
        },
        ease: Power4.easeOut,
      };
      TweenMax.to(window, 2, tweenOption);

      return false;
    },
    hashCheck(e) {
      e.preventDefault();
      if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname) {
        let $target = $(this.hash);
        if (this.hash.slice(1)) {
          $target = ($target.length && $target) || $(`[name=${this.hash.slice(1)}]`);
          if ($target.length) {
            let position = ($target.offset().top - getHeaderSize($('#collapse-navbar')));
            position = (position < 0) ?
              0 :
              position;
            scroll.animate(position);
          }
        }
      }
    },
    pageTop() {
      scroll.animate(0);
    },
    cancel() {
      TweenMax.killTweensOf(window);
    },
  };
  $(document)
    .on('click', '.go-top', scroll.pageTop)
    .on('click', 'a[href*="#"]:not(.no-hash,[target="_blank"])', scroll.hashCheck)
    .on('mousewheel DOMMouseScroll', scroll.cancel);
};

export default smoothScroll;



// WEBPACK FOOTER //
// ./src/scripts/common/smoothScroll.js